import React, { useEffect, useState } from "react";
import { CollectionRenderer } from "./BlogMapper";
import { getBlogHome } from "../../lib/getBlogHome";
import BlogBanner from "../../components/Blog/BlogBanner";
import BlogSkeleton from "../../components/Skeletons/BlogSkeleton/BlogSkeleton";
import styles from "./Blog.module.css";
import BlogHomeSEO from "../../components/SEO/BlogHomeSEO";

interface BlogContent {
  blogBanner: any[];
  collections: any[];
}

const Blog = () => {
  console.log("Blog component rendering");

  const [blogContent, setBlogContent] = useState<BlogContent>({
    blogBanner: [],
    collections: [],
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log("Blog useEffect running");
    const fetchBlogContent = async () => {
      try {
        setLoading(true);
        const data = await getBlogHome();
        console.log("Blog data received:", data);
        setBlogContent(data);
      } catch (error) {
        console.error("Error fetching blog content:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogContent();
  }, []);

  const { blogBanner, collections = [] } = blogContent;
  console.log("Blog render with content:", { blogBanner, collections });

  if (loading) {
    return <BlogSkeleton />;
  }

  return (
    <div
      className={`min-h-screen ${styles.blogContainer}`}
      aria-label="Página principal del blog de Evefant"
    >
      <BlogHomeSEO />
      <div className={styles.blogHero} aria-label="Banner principal del blog">
        <BlogBanner banners={blogBanner} />
      </div>

      <div
        className={`${styles.collectionsWrapper} ${styles.fadeInContent}`}
        aria-label="Colecciones de artículos del blog"
      >
        {collections?.map((collection, index) => (
          <div
            key={`collection-${index}`}
            className={styles.collectionGroup}
            aria-label={`Colección: ${collection.title || "Sin título"}`}
          >
            <CollectionRenderer collection={collection} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blog;
